import React, { useEffect, useState } from "react";
import { marketingApi, fmtUsd } from "../marketingApi";
import { Section, EmptyState, Loading } from "../components";
import { Input } from "@/components/ui/input";

const StatusBadge = ({ s }) => {
  const map = {
    new:        ["Nuevo", "bg-slate-100 text-slate-700"],
    submitted:  ["Enviado", "bg-sky-100 text-sky-800"],
    converted:  ["Convertido", "bg-emerald-100 text-emerald-800"],
  };
  const [label, cls] = map[s] || [s, "bg-slate-100 text-slate-700"];
  return <span className={`text-[11px] font-semibold px-2 py-0.5 rounded ${cls}`}>{label}</span>;
};

export default function LeadsTab() {
  const [leads, setLeads] = useState(null);
  const [filter, setFilter] = useState("");
  const [err, setErr] = useState(null);
  useEffect(() => {
    marketingApi.leads({ limit: 1000 })
      .then((d) => setLeads(d.leads || []))
      .catch((e) => setErr(e?.response?.data?.detail || "Error"));
  }, []);
  if (err) return <EmptyState title="Error al cargar" description={err} testId="leads-error" />;
  if (!leads) return <Loading />;
  const filtered = filter
    ? leads.filter((l) => JSON.stringify(l).toLowerCase().includes(filter.toLowerCase()))
    : leads;
  return (
    <div className="space-y-4" data-testid="leads-tab">
      <Section
        title="Leads y UTM"
        subtitle="Cada lead = una sesión única capturada en /join. La atribución a reservas se calcula por email."
        right={<Input data-testid="leads-filter" placeholder="Filtrar…" value={filter} onChange={(e) => setFilter(e.target.value)} className="w-56" />}
      >
        {leads.length === 0 ? (
          <EmptyState
            title="Aún no hay leads capturados"
            description="Comparte el formulario público /join (opcional: con parámetros UTM) para empezar a medir visitantes."
            testId="leads-empty"
          />
        ) : (
          <div className="overflow-x-auto -mx-5 sm:mx-0">
            <table className="w-full text-sm">
              <thead className="text-xs text-slate-500 uppercase tracking-wider">
                <tr className="border-b border-slate-200 dark:border-[#25334D]">
                  <th className="py-2 px-3 text-left">Fecha</th>
                  <th className="py-2 px-3 text-left">Email</th>
                  <th className="py-2 px-3 text-left">Fuente</th>
                  <th className="py-2 px-3 text-left">Medio</th>
                  <th className="py-2 px-3 text-left">Campaña</th>
                  <th className="py-2 px-3 text-left">Expedición</th>
                  <th className="py-2 px-3 text-right">Ingreso</th>
                  <th className="py-2 px-3 text-left">Estado</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((l) => (
                  <tr key={l.id || l.session_id} className="border-b border-slate-100 dark:border-[#1A2336]">
                    <td className="py-2 px-3 text-xs text-slate-500">{(l.created_at || "").slice(0, 10)}</td>
                    <td className="py-2 px-3">{l.email || <span className="text-slate-400">—</span>}</td>
                    <td className="py-2 px-3">{l.utm_source || <span className="text-slate-400">(direct)</span>}</td>
                    <td className="py-2 px-3 text-slate-500">{l.utm_medium || "—"}</td>
                    <td className="py-2 px-3 text-slate-500">{l.utm_campaign || "—"}</td>
                    <td className="py-2 px-3">{l.converted_tour_name || <span className="text-slate-400">—</span>}</td>
                    <td className="py-2 px-3 text-right font-medium">{l.revenue_usd ? fmtUsd(l.revenue_usd) : "—"}</td>
                    <td className="py-2 px-3"><StatusBadge s={l.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
            {filtered.length === 0 && <div className="py-6 text-center text-xs text-slate-500">Sin coincidencias para «{filter}».</div>}
          </div>
        )}
      </Section>
    </div>
  );
}
